import { SVGProps } from 'react'

export const NotesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9997 7.66663L11.9997 11.4666C11.9997 12.5867 11.9997 13.1468 11.7817 13.5746C11.5899 13.9509 11.284 14.2569 10.9077 14.4486C10.4798 14.6666 9.91978 14.6666 8.79967 14.6666L4.53301 14.6666C3.4129 14.6666 2.85285 14.6666 2.42503 14.4486C2.0487 14.2569 1.74274 13.9509 1.55099 13.5746C1.33301 13.1468 1.33301 12.5867 1.33301 11.4666L1.33301 4.53329C1.33301 3.41319 1.33301 2.85314 1.551 2.42531C1.74274 2.04899 2.0487 1.74303 2.42503 1.55128C2.85285 1.33329 3.41291 1.33329 4.53301 1.33329L6.66634 1.33329M9.33301 11.3333L3.99968 11.3333M5.333 8.66676L7.40058 8.07603C7.49958 8.04774 7.54909 8.0336 7.59526 8.0124C7.63626 7.99357 7.67524 7.97063 7.71161 7.94394C7.75256 7.91387 7.78897 7.87746 7.86178 7.80465L12.1664 3.50012C12.6266 3.03987 12.6266 2.29366 12.1664 1.83341C11.7061 1.37318 10.9599 1.37319 10.4997 1.83342L6.19512 6.13798C6.1223 6.2108 6.0859 6.2472 6.05583 6.28816C6.02913 6.32452 6.00619 6.36351 5.98737 6.40451C5.96617 6.45068 5.95202 6.50018 5.92374 6.59919L5.333 8.66676Z"
      stroke="#475467"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
